import { render } from "./MerchantManagement.vue?vue&type=template&id=61763e60&scoped=true"
import script from "./MerchantManagement.vue?vue&type=script&lang=js"
export * from "./MerchantManagement.vue?vue&type=script&lang=js"

import "./MerchantManagement.vue?vue&type=style&index=0&id=61763e60&scoped=true&lang=scss"
import "./MerchantManagement.vue?vue&type=style&index=1&id=61763e60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61763e60"]])

export default __exports__